module.exports = __webpack_public_path__ + "img/logo-image-4.39e06022.png";